'use client'

import {
    Box,
    Stack,
    Popover,
    PopoverTrigger,
    PopoverContent,
    useColorModeValue,
    PopoverArrow,
    Link,
    Flex,
} from '@chakra-ui/react'
import DesktopSubNav from './DesktopSubNav'
import styles from '../../NavBar.module.scss'
import { NavItems_t } from '../../NavBarTypes/NavItem'

export default function DesktopNavBar({ navItems }: NavItems_t) {
    const popoverContentBgColor = useColorModeValue('white', 'gray.800')

    return (
        <Stack className={styles['desktop__nav-bar__nav-item-stack']}
            direction={'row'} >
            {navItems.map((navItem) => (
                <Flex className={styles['nav-item__flex-container']}
                    width={"7rem"} justifyContent={"space-around"}
                    alignItems={"center"} key={navItem.label}>
                    <Box className={styles['nav-item__popover-container']}
                        key={navItem.label}
                        rounded={'xl'}
                        h={{ lg: "2.5rem" }}
                        alignContent={"center"}>
                        <Popover trigger={'hover'} placement={'bottom-start'} >
                            <PopoverTrigger >
                                <Link
                                    className={styles['nav-item__popover-trigger__link']}
                                    p={2}
                                    minW={"4rem"}
                                    href={navItem.href ?? '#'}
                                    fontWeight={500}
                                    fontSize={'1.2rem'}
                                    color={'white'}
                                    _hover={{
                                        textDecoration: 'none',
                                        color: "white",
                                    }}>
                                    {navItem.label}
                                </Link>
                            </PopoverTrigger>
                            <PopoverArrow />

                            {navItem.children && (
                                <PopoverContent
                                    border={0}
                                    boxShadow={'xl'}
                                    bg={popoverContentBgColor}
                                    p={4}
                                    rounded={'xl'}>
                                    <PopoverArrow />
                                    <Stack className={styles['nav-item-children__stack']}>
                                        {navItem.children.map((child) => (
                                            <DesktopSubNav key={child.label} {...child} />
                                        ))}
                                    </Stack>
                                </PopoverContent>
                            )}
                        </Popover>
                    </Box>
                    <Box className={styles['nav-item__separator-container']}>|</Box>
                </Flex>
            ))}
        </Stack>
    )
}

